import React from "react";
import { motion, useScroll, useSpring, useTransform } from "framer-motion";

const BeeScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  
  // Smooth out the progress bar movement
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  // Calculate rotation for the bee so it "wobbles" as it flies
  const rotate = useTransform(scrollYProgress, [0, 1], [0, 10]);

  return (
    <div className="fixed top-25 left-0 right-0 h-1.5 bg-[#d3a863]/20 z-[200]">
      {/* The Honey Trail */}
      <motion.div
        className="absolute top-0 left-0 right-0 h-full bg-[#f57c00] origin-left"
        style={{ scaleX }}
      />

      {/* The Flying Bee */}
      <motion.div
        className="absolute top-[-15px] text-2xl"
        style={{ 
          left: useTransform(scrollYProgress, [0, 1], ["0%", "98%"]),
          rotate: rotate 
        }}
      >
        <motion.span
          animate={{ y: [0, -4, 0] }}
          transition={{ repeat: Infinity, duration: 0.5 }}
          style={{ display: "inline-block" }}
        >
          🐝
        </motion.span>
      </motion.div>
    </div>
  );
};

export default BeeScrollProgress;